(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1498,65250],{

/***/ 1498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DebtReliefOfficeWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/debtreliefoffice/logo/index.tsx


function DebtReliefOfficeLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "200",
        height: "28",
        fill: "none",
        viewBox: "0 0 285 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_12)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#0071AC",
                        d: "M33.908 5.56s-.005.04-.02.067c-.011.02-.022.031-.032.047-.037.042-.079.078-.12.115.11-.1-.23.094-.115.047-.173.063-.199.057-.382.057-.193-.01-.303-.047-.506-.182.11.073-.147-.215-.058-.079-.068-.104-.042-.02-.042-.125 0-.016.005-.042.021-.068.01-.021.021-.031.031-.047a1.25 1.25 0 01.12-.115c-.11.1.23-.094.116-.047.172-.063.198-.058.381-.058.193 0 .308.053.507.183-.11-.073.146.215.057.079.068.104.042.02.042.125zm-1.593 4.811c-.82 2.168-1.646 4.331-2.466 6.5h-1.95c.016-.09.032-.178.037-.272.006-.047.016-.094.021-.141 1.29-.277 2.383-1.228 2.456-2.644.062-1.155-.716-2.017-1.688-2.471.251-1.693.507-3.386.758-5.073.104-.716.214-1.432.319-2.148.49.105.982.215 1.473.324a2.14 2.14 0 00-.371 1.066c-.084 1.212 1.092 1.985 2.163 2.116.057.01.115.016.178.016H33.358c-.344.914-.694 1.828-1.04 2.743l-.005-.016zm-1.056 9.159c.277.162.564.507.664.757.183.455.172.794.015 1.26-.036.11-.151.323-.26.496-.048.078-.105.157-.158.23.042-.058-.099.115-.115.136a4.297 4.297 0 01-.438.433c-.413.335-.23.936.12 1.218-.147-.11.01.005.057.047.147.125.282.26.413.407.1.11.23.298.355.544.073.146.141.423.141.621 0 .194-.078.512-.14.659-.11.25-.262.48-.424.7.042-.058-.125.151-.157.183l-.188.203c-.057.058-.12.115-.183.173-.496.423-.156 1.128.35 1.327-.334-.126-.099-.042 0 .015.053.032.105.063.157.1.042.031.079.068.115.104.026.026.146.167.146.162.068.094.126.194.178.298.005.01.01.02.016.026 0 .01.01.031.02.068.027.078.048.157.068.24.042.168.037.235.042.44 0 .292-.041.527-.151.825.015-.042-.058.13-.058.13a3.268 3.268 0 01-.225.366s0 .005-.005.01c-.005.006-.015.016-.026.032-.099.12-.209.23-.329.329-.036.026-.1.073-.136.094-.522.303-.48.988-.047 1.332l.11.094c.073.063.141.136.204.204.042.042.078.089.115.13.01.011.015.022.02.027.016.026.037.047.053.073.198.282.282.475.366.726.12.387.125.706.088 1.124a1.472 1.472 0 01-.783 1.17.969.969 0 00-.13.063c-.058.02-.11.036-.168.052-.073.02-.152.036-.225.052-.026.005-.042.01-.057.01h-.047c-.115.011-.235.016-.355.016H13.579c-.648 0-1.087-.172-1.468-.705-.44-.611-.507-1.254-.507-1.996V21.823a18.255 18.255 0 01.183-2.81c0-.027.01-.058.015-.084 1.855-1.202 3.705-2.403 5.56-3.6 0 .052.01.1.015.152.058.564.115 1.128.167 1.693.021.193.021.397.063.585a1.905 1.905 0 001.129 1.327c.12.099.282.162.485.162h11.072c.355 0 .663.094.966.271v.01zM18.443 4.587a.88.88 0 00.172.016h.1c1.128-.047 2.116-.784 2.194-1.965a1.63 1.63 0 00-.057-.559h4.32a1.906 1.906 0 00-.094.486c-.078 1.16 1.045 1.897 2.064 2.022a.88.88 0 00.172.016h.1c.13-.005.261-.02.386-.042-.041.267-.078.533-.12.8-.527 3.537-1.055 7.079-1.588 10.616 0 .016 0 .031-.005.042 0 .016 0 .031-.006.047-.015.057-.02.115-.026.172v.058c-.005.01-.015.031-.031.078.037-.11-.073.068-.031.026a.45.45 0 01-.246.13c.037-.01-.13 0-.183 0h-6.102c-.188 0-.308-.093-.36-.219 0-.01-.021-.11-.021-.135l-.048-.486c-.37-3.741-.747-7.487-1.118-11.233.178.057.36.099.538.12l-.01.01zm-.408-2.006s.006-.042.021-.068a.491.491 0 00.027-.042c.036-.036.073-.073.115-.11-.105.095.219-.088.11-.046.161-.058.187-.058.365-.058.183 0 .293.047.486.172-.105-.067.14.204.057.074.068.099.037.02.037.12a.14.14 0 01-.021.068.464.464 0 00-.026.042c-.037.036-.073.073-.115.11.104-.095-.22.088-.11.046-.162.058-.188.058-.366.058-.188-.01-.287-.042-.485-.173.104.068-.142-.203-.058-.073-.068-.1-.037-.02-.037-.12zm8.7.005s.005-.042.02-.068l.027-.041c.036-.037.073-.074.115-.11-.105.094.219-.089.11-.047.161-.058.187-.058.365-.058.183 0 .293.047.486.173-.105-.068.141.203.057.073.068.1.037.02.037.12a.14.14 0 01-.021.068l-.026.042c-.037.036-.073.073-.115.11.105-.095-.22.088-.11.046-.162.058-.188.058-.366.058-.188-.01-.287-.042-.485-.172.104.067-.141-.204-.058-.074-.068-.099-.036-.02-.036-.12zm1.703 10.632c.078.079.047.047.136.188.073.12.099.236.099.413a.952.952 0 01-.094.324s-.11.157-.094.146a2.188 2.188 0 01-.225.215c.016-.016.005-.01-.01 0 .062-.429.13-.862.193-1.29l-.005.004zm7.445-7.382c.319-.841-.272-1.75-.914-2.215-.272-.199-.606-.272-.93-.34-.831-.183-1.662-.36-2.498-.543-.496-.11-.998-.214-1.494-.324 0-.032.01-.063.016-.1.13-.862-.371-1.729-1.165-2.079-.366-.162-.742-.209-1.14-.209H18.94c-.679 0-1.384-.068-2.016.21-.935.412-1.249 1.331-1.16 2.261l.987 9.901c-1.416.915-2.826 1.834-4.242 2.748-.805.523-1.615 1.045-2.42 1.568L9.646 17c-.528.34-.502 1.113-.57 1.667-.047.366-.078.731-.104 1.097H.867a.875.875 0 00-.867.867v17.56c0 .47.392.868.867.868h9.055c.12 0 .23-.021.324-.058a3.473 3.473 0 002.481 1.008h18.287c1.243 0 2.335-.444 3.098-1.441.851-1.113.773-2.811.24-4.034a4.42 4.42 0 00-.627-1.024c1.28-1.463 1.374-3.945.032-5.298.58-.742.971-1.656.992-2.576.021-.93-.423-1.818-1.055-2.513.69-.825 1.134-1.907 1.04-2.957-.152-1.666-1.448-2.978-3.052-3.24l2.79-7.35c.476-1.249.946-2.498 1.421-3.741h-.01zm-14.425 5.893s.11-.156.094-.146c.068-.078.146-.146.224-.214-.052.047.168-.1.157-.094.125-.073.146-.079.246-.115.271-.094.439-.105.716-.105.219 0 .38.042.61.115.043.01.063.021.08.027 0 0 .025.015.083.046.036.021.245.147.235.136.073.058.136.12.198.188.079.079.047.047.136.188.073.12.1.236.1.413a.952.952 0 01-.095.324s-.114.157-.094.146c-.067.079-.146.147-.224.215.052-.053-.168.099-.157.094-.125.073-.146.078-.246.115-.271.094-.438.11-.715.104a2.205 2.205 0 01-.612-.115c-.041-.01-.062-.02-.078-.026 0 0-.026-.016-.084-.047-.036-.02-.245-.146-.235-.136a1.682 1.682 0 01-.198-.188c-.079-.078-.047-.047-.136-.188a.724.724 0 01-.1-.413c0-.078.053-.245.095-.324zm1.233 3.161c.036 0 .073.005.11.005 1.609.011 3.176-1.024 3.265-2.732.089-1.714-1.662-2.78-3.171-2.847-1.61-.068-3.182 1.07-3.266 2.732-.089 1.672 1.578 2.727 3.062 2.837v.005z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M4.833 27.372a1.87 1.87 0 100-3.741 1.87 1.87 0 000 3.741z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#0071AC",
                        d: "M49.096 12.633h5.706c1.483 0 2.758.136 3.819.413a7.048 7.048 0 012.889 1.546c2.252 1.928 3.375 4.854 3.375 8.783 0 1.296-.115 2.482-.34 3.553a10.44 10.44 0 01-1.044 2.894 8.968 8.968 0 01-1.813 2.31c-.58.522-1.213.94-1.902 1.254a8.56 8.56 0 01-2.22.663c-.79.126-1.683.194-2.676.194h-5.705c-.794 0-1.395-.12-1.797-.361a1.689 1.689 0 01-.79-1.019c-.125-.439-.182-1.003-.182-1.703V15.314c0-.946.209-1.625.632-2.049.423-.423 1.108-.632 2.048-.632zm1.693 3.464v14.666h3.318c.726 0 1.295-.021 1.708-.058a5.178 5.178 0 001.28-.292 3.42 3.42 0 001.15-.664c1.462-1.238 2.194-3.37 2.194-6.395 0-2.131-.324-3.73-.967-4.79-.642-1.061-1.437-1.735-2.382-2.028-.946-.287-2.085-.434-3.422-.434h-2.89l.01-.005zM79.08 27.42h-7.873c.01.913.193 1.718.554 2.418.36.7.836 1.223 1.431 1.578a3.764 3.764 0 001.97.533c.48 0 .92-.058 1.317-.167a4.186 4.186 0 001.154-.533 9.871 9.871 0 001.035-.773 57.41 57.41 0 001.222-1.119c.21-.177.502-.266.883-.266.413 0 .747.115 1.003.34.256.224.382.543.382.956 0 .365-.141.789-.429 1.274-.287.486-.715.951-1.29 1.4-.575.45-1.296.821-2.168 1.114-.873.292-1.87.444-3 .444-2.585 0-4.592-.737-6.029-2.21-1.436-1.474-2.152-3.475-2.152-5.998 0-1.192.177-2.294.533-3.308.355-1.018.867-1.89 1.546-2.617a6.716 6.716 0 012.508-1.672c.993-.387 2.095-.58 3.302-.58 1.573 0 2.92.33 4.044.993 1.123.663 1.97 1.52 2.529 2.57.559 1.05.84 2.122.84 3.213 0 1.014-.286 1.667-.866 1.97-.58.298-1.395.45-2.445.45v-.01zm-7.873-2.284h7.299c-.1-1.374-.47-2.403-1.113-3.088-.643-.684-1.49-1.024-2.544-1.024-1.056 0-1.824.345-2.472 1.04-.642.695-1.034 1.719-1.17 3.072zM88.5 14.566v6.15c.758-.784 1.526-1.39 2.315-1.808.784-.418 1.76-.627 2.92-.627 1.338 0 2.508.319 3.517.95 1.008.633 1.787 1.553 2.346 2.76.559 1.206.83 2.633.83 4.284 0 1.217-.156 2.335-.465 3.354-.308 1.019-.757 1.896-1.347 2.644a6.13 6.13 0 01-2.143 1.734c-.836.408-1.766.611-2.78.611a6.709 6.709 0 01-1.744-.219 5.191 5.191 0 01-1.395-.58 6.791 6.791 0 01-.982-.742 16.678 16.678 0 01-1.072-1.15v.398c0 .758-.182 1.327-.543 1.719-.365.386-.825.58-1.384.58-.56 0-1.024-.194-1.364-.58-.34-.387-.507-.961-.507-1.72V14.74c0-.815.162-1.432.497-1.85.329-.418.788-.627 1.379-.627.622 0 1.097.199 1.431.596.335.397.502.966.502 1.703l-.01.005zm.194 11.954c0 1.604.366 2.832 1.097 3.694.731.862 1.693 1.29 2.884 1.29 1.014 0 1.886-.438 2.618-1.316.731-.878 1.097-2.142 1.097-3.783 0-1.06-.152-1.975-.455-2.743-.303-.768-.736-1.358-1.296-1.776-.558-.418-1.212-.627-1.959-.627a3.54 3.54 0 00-2.048.627c-.6.418-1.07 1.024-1.416 1.813-.344.789-.517 1.73-.517 2.821h-.005zM103.271 18.605h.444v-2.42c0-.647.015-1.154.052-1.525.037-.37.131-.684.287-.95a1.78 1.78 0 01.68-.67c.297-.172.621-.255.987-.255.512 0 .972.193 1.385.574a1.7 1.7 0 01.522.936c.073.37.11.893.11 1.567v2.743h1.473c.57 0 1.003.136 1.306.407.298.272.45.617.45 1.04 0 .538-.215.92-.643 1.134-.428.214-1.04.324-1.834.324h-.752v7.398c0 .627.021 1.113.068 1.452.041.34.162.617.355.826.193.209.502.319.935.319.235 0 .554-.042.956-.126.403-.083.716-.125.946-.125.324 0 .616.13.878.392.261.26.392.58.392.966 0 .648-.356 1.145-1.061 1.49-.705.344-1.724.517-3.051.517-1.259 0-2.21-.21-2.858-.633a2.938 2.938 0 01-1.275-1.755c-.204-.747-.303-1.745-.303-2.994v-7.722h-.533c-.58 0-1.024-.136-1.327-.413a1.35 1.35 0 01-.455-1.045c0-.423.162-.768.481-1.04.319-.271.784-.407 1.395-.407l-.01-.005zM122.612 25h-1.53v6.944c0 .914-.204 1.588-.607 2.021-.402.434-.93.648-1.577.648-.7 0-1.239-.224-1.62-.679-.381-.454-.575-1.113-.575-1.99V15.319c0-.946.209-1.625.632-2.048.424-.424 1.108-.633 2.049-.633h7.121c.982 0 1.823.042 2.518.126.695.083 1.327.25 1.886.507a5.54 5.54 0 011.797 1.222c.523.533.915 1.15 1.186 1.85.272.7.408 1.447.408 2.23 0 1.61-.455 2.9-1.364 3.862-.909.961-2.288 1.645-4.132 2.048.778.412 1.52 1.024 2.225 1.828a18.9 18.9 0 011.897 2.57c.554.91.987 1.73 1.296 2.462.308.731.465 1.238.465 1.51 0 .271-.089.57-.272.846a1.949 1.949 0 01-.742.664 2.354 2.354 0 01-1.092.245c-.491 0-.904-.115-1.238-.345a3.271 3.271 0 01-.862-.877c-.241-.356-.57-.873-.983-1.563l-1.755-2.92c-.627-1.071-1.191-1.886-1.688-2.445-.496-.56-.998-.946-1.51-1.15-.512-.203-1.154-.308-1.933-.308zm2.508-9.08h-4.038v5.94H125c1.05 0 1.938-.089 2.654-.272.716-.183 1.265-.49 1.646-.93.376-.439.569-1.04.569-1.808 0-.6-.151-1.128-.454-1.583a2.747 2.747 0 00-1.27-1.024c-.512-.214-1.52-.323-3.02-.323h-.005zM148.041 27.42h-7.874c.011.913.194 1.718.554 2.418.361.7.836 1.223 1.432 1.578a3.76 3.76 0 001.969.533 5 5 0 001.322-.167c.402-.11.784-.288 1.155-.533a9.234 9.234 0 001.029-.773c.313-.277.721-.648 1.223-1.119.209-.177.501-.266.883-.266.412 0 .747.115 1.003.34.256.224.381.543.381.956 0 .365-.141.789-.428 1.274-.288.486-.716.951-1.291 1.4-.575.45-1.296.821-2.168 1.114-.873.292-1.87.444-2.999.444-2.586 0-4.592-.737-6.029-2.21-1.437-1.474-2.153-3.475-2.153-5.998 0-1.192.178-2.294.533-3.308.355-1.018.867-1.89 1.547-2.617a6.717 6.717 0 012.507-1.672c.993-.387 2.096-.58 3.302-.58 1.573 0 2.921.33 4.044.993 1.124.663 1.97 1.52 2.529 2.57.559 1.05.841 2.122.841 3.213 0 1.014-.287 1.667-.867 1.97-.58.298-1.395.45-2.445.45v-.01zm-7.874-2.284h7.299c-.099-1.374-.47-2.403-1.113-3.088-.642-.684-1.489-1.024-2.544-1.024-1.056 0-1.824.345-2.471 1.04-.643.695-1.035 1.719-1.171 3.072zM154.148 32.163v-17.45c0-.805.178-1.416.539-1.83.36-.412.841-.62 1.452-.62s1.102.203 1.473.61c.371.408.559 1.02.559 1.834v17.45c0 .816-.188 1.427-.569 1.835-.382.407-.867.61-1.468.61s-1.071-.208-1.437-.631c-.366-.423-.554-1.03-.554-1.813l.005.005zM163.757 16.38c-.56 0-1.04-.173-1.437-.518-.397-.345-.596-.83-.596-1.458 0-.57.204-1.04.611-1.405a2.048 2.048 0 011.422-.554c.538 0 .982.167 1.384.502.402.334.606.82.606 1.457 0 .638-.198 1.103-.59 1.453-.392.35-.862.522-1.4.522zm1.99 4.158v11.63c0 .805-.193 1.416-.575 1.829-.381.413-.872.621-1.457.621-.585 0-1.071-.209-1.437-.632-.366-.423-.554-1.029-.554-1.813v-11.51c0-.794.183-1.395.554-1.797.371-.402.846-.606 1.437-.606.59 0 1.076.204 1.457.606.382.402.575.962.575 1.683v-.01zM180.533 27.42h-7.874c.011.913.194 1.718.554 2.418.361.7.836 1.223 1.432 1.578a3.76 3.76 0 001.969.533 5 5 0 001.322-.167 3.97 3.97 0 001.155-.533c.371-.24.716-.497 1.029-.773.314-.277.721-.648 1.223-1.119.204-.177.501-.266.883-.266.412 0 .747.115 1.003.34.256.224.381.543.381.956 0 .365-.141.789-.428 1.274-.288.486-.716.951-1.291 1.4-.574.45-1.295.821-2.168 1.114-.867.292-1.87.444-2.999.444-2.586 0-4.592-.737-6.029-2.21-1.437-1.474-2.153-3.475-2.153-5.998 0-1.192.178-2.294.533-3.308.356-1.018.873-1.89 1.547-2.617.679-.726 1.515-1.285 2.508-1.672.992-.387 2.095-.58 3.302-.58 1.572 0 2.92.33 4.049.993 1.123.663 1.969 1.52 2.528 2.57.559 1.05.842 2.122.842 3.213 0 1.014-.288 1.667-.868 1.97-.58.298-1.395.45-2.445.45l-.005-.01zm-7.874-2.284h7.299c-.099-1.374-.47-2.403-1.113-3.088-.642-.684-1.489-1.024-2.544-1.024s-1.823.345-2.471 1.04c-.643.695-1.035 1.719-1.171 3.072zM186.311 18.605h.957v-1.207c0-1.259.161-2.257.48-2.999.319-.742.862-1.28 1.62-1.62.763-.34 1.808-.506 3.135-.506 2.351 0 3.521.574 3.521 1.724 0 .37-.125.695-.371.956a1.145 1.145 0 01-.867.397c-.157 0-.429-.031-.81-.089a6.725 6.725 0 00-.972-.089c-.726 0-1.196.215-1.4.643-.209.428-.308 1.04-.308 1.834v.956h.987c1.531 0 2.299.46 2.299 1.384 0 .659-.204 1.077-.611 1.254-.408.178-.972.267-1.688.267h-.987v10.658c0 .794-.188 1.406-.57 1.818-.376.418-.867.627-1.468.627s-1.045-.209-1.421-.627c-.376-.418-.569-1.024-.569-1.818V21.51h-1.108c-.601 0-1.061-.136-1.385-.408a1.31 1.31 0 01-.486-1.055c0-.961.674-1.442 2.022-1.442zM210.758 12.262c2.241 0 4.164.455 5.768 1.364 1.609.909 2.821 2.2 3.646 3.877.826 1.677 1.239 3.641 1.239 5.904 0 1.671-.225 3.186-.68 4.555-.454 1.37-1.128 2.55-2.032 3.553-.904 1.003-2.017 1.771-3.333 2.299-1.317.528-2.827.794-4.525.794-1.698 0-3.203-.271-4.54-.82-1.338-.543-2.45-1.317-3.344-2.31-.893-.992-1.567-2.183-2.027-3.584-.455-1.394-.684-2.904-.684-4.524s.24-3.182.715-4.572c.476-1.39 1.165-2.565 2.069-3.537a8.935 8.935 0 013.302-2.23c1.296-.518 2.769-.774 4.42-.774l.006.005zm6.222 11.113c0-1.583-.256-2.952-.768-4.112-.512-1.16-1.243-2.037-2.189-2.633-.951-.595-2.038-.893-3.265-.893-.873 0-1.683.162-2.425.49-.742.33-1.379.81-1.917 1.438-.538.627-.956 1.431-1.27 2.408-.313.977-.465 2.074-.465 3.297 0 1.223.157 2.34.465 3.333.309.993.747 1.818 1.312 2.471a5.508 5.508 0 001.943 1.469 5.89 5.89 0 002.409.486 5.938 5.938 0 003.088-.842c.94-.559 1.687-1.426 2.241-2.596.554-1.17.831-2.607.831-4.321l.01.005zM223.95 18.605h.956v-1.207c0-1.259.162-2.257.481-2.999.318-.742.862-1.28 1.619-1.62.763-.34 1.808-.506 3.135-.506 2.351 0 3.522.574 3.522 1.724 0 .37-.126.695-.371.956a1.148 1.148 0 01-.868.397c-.156 0-.428-.031-.81-.089a6.725 6.725 0 00-.971-.089c-.727 0-1.197.215-1.401.643-.209.428-.308 1.04-.308 1.834v.956h.988c1.53 0 2.298.46 2.298 1.384 0 .659-.203 1.077-.611 1.254-.407.178-.972.267-1.687.267h-.988v10.658c0 .794-.188 1.406-.569 1.818-.376.418-.868.627-1.468.627-.601 0-1.045-.209-1.422-.627-.376-.418-.569-1.024-.569-1.818V21.51h-1.108c-.6 0-1.06-.136-1.384-.408a1.31 1.31 0 01-.486-1.055c0-.961.674-1.442 2.022-1.442zM234.519 18.605h.956v-1.207c0-1.259.162-2.257.481-2.999.319-.742.862-1.28 1.62-1.62.763-.34 1.807-.506 3.135-.506 2.351 0 3.521.574 3.521 1.724 0 .37-.125.695-.371.956-.246.266-.538.397-.867.397-.157 0-.429-.031-.81-.089a6.725 6.725 0 00-.972-.089c-.726 0-1.196.215-1.4.643-.209.428-.308 1.04-.308 1.834v.956h.987c1.531 0 2.299.46 2.299 1.384 0 .659-.204 1.077-.611 1.254-.408.178-.972.267-1.688.267h-.987v10.658c0 .794-.188 1.406-.57 1.818-.376.418-.867.627-1.468.627s-1.045-.209-1.421-.627c-.376-.418-.57-1.024-.57-1.818V21.51h-1.107c-.601 0-1.061-.136-1.385-.408a1.31 1.31 0 01-.486-1.055c0-.961.674-1.442 2.022-1.442zM246.698 16.38c-.559 0-1.04-.173-1.437-.518-.397-.345-.595-.83-.595-1.458 0-.57.203-1.04.611-1.405a2.045 2.045 0 011.421-.554c.538 0 .982.167 1.385.502.402.334.606.82.606 1.457 0 .638-.199 1.103-.591 1.453-.392.35-.862.522-1.4.522zm1.991 4.158v11.63c0 .805-.194 1.416-.575 1.829-.381.413-.873.621-1.458.621s-1.071-.209-1.437-.632c-.365-.423-.553-1.029-.553-1.813v-11.51c0-.794.182-1.395.553-1.797.371-.402.847-.606 1.437-.606.591 0 1.077.204 1.458.606s.575.962.575 1.683v-.01zM266.672 29.63c0 .5-.152 1.034-.449 1.608-.298.57-.758 1.113-1.369 1.63-.617.518-1.39.93-2.32 1.244-.935.313-1.985.47-3.156.47-2.487 0-4.425-.726-5.82-2.173-1.395-1.447-2.095-3.391-2.095-5.831 0-1.651.319-3.109.956-4.378a6.876 6.876 0 012.769-2.942c1.207-.695 2.654-1.04 4.331-1.04 1.04 0 1.996.152 2.869.455.872.303 1.609.7 2.21 1.18.606.481 1.066.993 1.384 1.542.319.544.481 1.056.481 1.526s-.178.888-.538 1.222a1.85 1.85 0 01-1.306.502c-.335 0-.612-.084-.831-.256-.22-.173-.47-.45-.742-.83-.491-.748-1.003-1.307-1.541-1.683-.538-.371-1.218-.56-2.043-.56-1.191 0-2.147.466-2.874 1.396-.726.93-1.092 2.2-1.092 3.808 0 .758.094 1.453.282 2.085.189.632.46 1.176.81 1.62.35.444.784.784 1.286 1.019.501.23 1.05.344 1.651.344.804 0 1.494-.188 2.069-.559.574-.37 1.081-.945 1.525-1.708.246-.45.512-.805.794-1.06.282-.257.632-.382 1.045-.382.491 0 .899.188 1.223.559.324.37.486.773.486 1.196l.005-.005zM280.805 27.42h-7.874c.01.913.193 1.718.554 2.418.36.7.836 1.223 1.431 1.578a3.766 3.766 0 001.97.533 5 5 0 001.322-.167c.402-.11.784-.288 1.155-.533.371-.24.715-.497 1.029-.773.313-.277.721-.648 1.222-1.119.204-.177.502-.266.883-.266.413 0 .748.115 1.004.34.256.224.381.543.381.956 0 .365-.141.789-.428 1.274-.288.486-.716.951-1.291 1.4-.575.45-1.296.821-2.168 1.114-.868.292-1.871.444-2.999.444-2.586 0-4.593-.737-6.029-2.21-1.437-1.474-2.153-3.475-2.153-5.998 0-1.192.178-2.294.533-3.308.355-1.018.872-1.89 1.546-2.617a6.729 6.729 0 012.508-1.672c.993-.387 2.095-.58 3.302-.58 1.573 0 2.921.33 4.049.993 1.124.663 1.97 1.52 2.529 2.57.559 1.05.841 2.122.841 3.213 0 1.014-.287 1.667-.867 1.97-.58.298-1.395.45-2.445.45l-.005-.01zm-7.874-2.284h7.299c-.099-1.374-.47-2.403-1.113-3.088-.643-.684-1.489-1.024-2.544-1.024-1.056 0-1.824.345-2.472 1.04-.642.695-1.034 1.719-1.17 3.072z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H284.122V40H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (DebtReliefOfficeLogo);

// EXTERNAL MODULE: ./src/styles/variables/debtreliefofficeVariables.module.scss
var debtreliefofficeVariables_module = __webpack_require__(99130);
var debtreliefofficeVariables_module_default = /*#__PURE__*/__webpack_require__.n(debtreliefofficeVariables_module);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/debtReliefOfficeWrapper.tsx









const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function DebtReliefOfficeWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Debt Relief",
                    domain: "DebtReliefOffice.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Debt Relief ",
                    domain: "DebtReliefOffice.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "Find the Right debt relief For You",
                        phoneNumberColor: (debtreliefofficeVariables_module_default()).mainColor,
                        iconColor: (debtreliefofficeVariables_module_default()).mainColor,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 99130:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#0071ac"};

/***/ })

}]);